// ============================================================================
// LorenZone — Client API Ma Collection V2 (Edge Function « lz-mc »)
// ----------------------------------------------------------------------------
// Rétrocompatible avec la v1 : mêmes méthodes, mêmes réponses
// ({ ok: true, data } | { ok: false, error }). Le paramètre `email` des
// méthodes est conservé pour compatibilité mais N'EST PLUS UTILISÉ : l'identité
// est prouvée par un jeton signé côté serveur Shopify (snippet lz-mc-auth),
// impossible à fabriquer depuis le navigateur.
//
// Trois améliorations transparentes pour les traqueurs existants (rzc-*.js) :
//  1. Mode VISITEUR : sans compte, les cartes cochées sont gardées dans ce
//     navigateur (localStorage) au lieu de renvoyer vers la page de connexion.
//     Rien n'est envoyé au serveur ; l'import se propose après connexion.
//  2. Progression DÉDOUBLONNÉE : les traqueurs appelaient syncProgress à chaque
//     recalcul (chargement, préchargement, ouverture du panneau…). On n'envoie
//     plus qu'une requête par vrai changement, regroupée sur 1,5 s.
//  3. Événement « lz:mc:state » à chaque recalcul, pour la barre de vente.
// ============================================================================
(function () {
  if (window.lzApi && window.lzApi.__v === 2) return;

  var BASE_URL =
    (window.LZ_SUPABASE_URL || 'https://tjsehkvwematlyupthzl.supabase.co').replace(/\/$/, '') +
    '/functions/v1/lz-mc';
  var ANON_KEY = window.LZ_SUPABASE_ANON_KEY || '';
  var TOKEN_MAX_AGE_S = 11 * 3600; // le serveur accepte 12 h ; on rafraîchit avant
  var IS_CUSTOMER = window.LZ_MC_CUSTOMER === true; // rendu par layout/theme.liquid

  // --------------------------------------------------------------------------
  // Jeton signé
  // --------------------------------------------------------------------------
  function readAuth(doc) {
    var el = (doc || document).getElementById('lz-mc-auth');
    if (!el) return null;
    try {
      var a = JSON.parse(el.textContent || '{}');
      if (a && a.cid && a.email && a.ts && a.sig) return a;
    } catch (e) {}
    return null;
  }
  var auth = readAuth();
  var refreshing = null;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function refreshAuth() {
    if (refreshing) return refreshing;
    refreshing = fetch(rootUrl() + '?section_id=lz-mc-auth&_lzmc=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var a = readAuth(new DOMParser().parseFromString(html, 'text/html'));
        if (a) auth = a;
        return a;
      })
      .catch(function () { return null; })
      .then(function (a) { refreshing = null; return a; });
    return refreshing;
  }
  function tokenFresh() { return !!auth && Date.now() / 1000 - Number(auth.ts) < TOKEN_MAX_AGE_S; }
  function hasAuth() { if (!auth) auth = readAuth(); return !!auth; }

  // --------------------------------------------------------------------------
  // Mode visiteur : collection locale (aucune donnée envoyée)
  // --------------------------------------------------------------------------
  var GKEY = 'lzmc:guest:v1';
  var U_ALIAS = { lorcana: 'lor', lor: 'lor', pkm: 'pkm', pokemon: 'pkm', op: 'op', naruto: 'naruto', nar: 'naruto' };
  var guest = {
    read: function () {
      try { var o = JSON.parse(localStorage.getItem(GKEY) || '{}'); return o && typeof o === 'object' ? o : {}; } catch (e) { return {}; }
    },
    write: function (o) { try { o._at = Date.now(); localStorage.setItem(GKEY, JSON.stringify(o)); } catch (e) {} },
    bucket: function (o, u) {
      u = U_ALIAS[u] || u;
      o[u] = o[u] || {};
      o[u].p = o[u].p || {}; o[u].v = o[u].v || {}; o[u].g = o[u].g || {};
      return o[u];
    },
    count: function () {
      var o = guest.read(), n = 0;
      Object.keys(o).forEach(function (u) { if (u.charAt(0) !== '_' && o[u] && o[u].p) n += Object.keys(o[u].p).length; });
      return n;
    },
    clear: function () { try { localStorage.removeItem(GKEY); } catch (e) {} },
  };

  function ok(data) { return Promise.resolve({ ok: true, data: data }); }

  function guestCall(action, p) {
    var o = guest.read();
    var b;
    switch (action) {
      case 'collection.load':
        b = guest.bucket(o, p.universe);
        return ok({ products: Object.keys(b.p), variants: Object.keys(b.v) });
      case 'collection.toggleProduct':
        b = guest.bucket(o, p.universe);
        if (p.owned) b.p[String(p.product_id)] = { s: p.series_handle || '', t: (p.product_title || '').slice(0, 120) };
        else delete b.p[String(p.product_id)];
        guest.write(o);
        return ok({ owned: !!p.owned, local: true });
      case 'collection.toggleVariant':
        b = guest.bucket(o, p.universe);
        if (p.owned) b.v[String(p.variant_id)] = { s: p.series_handle || '', t: (p.product_title || '').slice(0, 120), k: p.variant_kind || '' };
        else delete b.v[String(p.variant_id)];
        guest.write(o);
        return ok({ owned: !!p.owned, local: true });
      case 'collection.syncProgress':
        b = guest.bucket(o, p.universe);
        if ((p.owned_cards || 0) + (p.owned_reverse_cards || 0) > 0 || b.g[p.series_handle]) {
          b.g[p.series_handle] = {
            universe: U_ALIAS[p.universe] || p.universe, series_handle: p.series_handle, series_title: p.series_title || '',
            total_cards: p.total_cards || 0, owned_cards: p.owned_cards || 0,
            total_reverse_cards: p.total_reverse_cards || 0, owned_reverse_cards: p.owned_reverse_cards || 0,
            updated_at: new Date().toISOString(),
          };
          guest.write(o);
        }
        return ok({ synced: true, local: true });
      case 'progress.getAll':
        var rows = [];
        Object.keys(o).forEach(function (u) { if (u.charAt(0) !== '_' && o[u] && o[u].g) Object.keys(o[u].g).forEach(function (h) { rows.push(o[u].g[h]); }); });
        return ok({ progress: rows, local: true });
      case 'favorites.list':
        return ok({ favorites: [], local: true });
      case 'preferences.get':
        return ok({ preferences: null, local: true });
      case 'activity.log':
        return ok({ logged: false, local: true, firstDate: null });
      default:
        return Promise.resolve({ ok: false, error: 'not_logged_in' });
    }
  }

  // --------------------------------------------------------------------------
  // Transport
  // --------------------------------------------------------------------------
  function send(action, payload, keepalive) {
    return fetch(BASE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + ANON_KEY, apikey: ANON_KEY },
      body: JSON.stringify({ action: action, auth: auth, payload: payload || {} }),
      credentials: 'omit',
      keepalive: !!keepalive,
    });
  }
  function parse(res) {
    return res.json().then(
      function (b) {
        if (!res.ok && b && b.ok !== false) return { ok: false, error: 'http_' + res.status };
        return b || { ok: false, error: 'empty_response' };
      },
      function () { return { ok: false, error: 'invalid_json_response' }; }
    );
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /**
   * Appel bas niveau. Rafraîchit le jeton s'il est ancien ou refusé, réessaie
   * une fois en cas de coupure réseau (toutes les écritures sont idempotentes).
   */
  var WRITE_ACTIONS = { 'collection.toggleProduct': 1, 'collection.toggleVariant': 1, 'collection.syncProgress': 1, 'collection.bulkSet': 1, 'favorites.toggle': 1, 'preferences.set': 1, 'wishlist.add': 1, 'wishlist.remove': 1, 'account.delete': 1 };
  async function call(action, payload, opts) {
    opts = opts || {};
    if (WRITE_ACTIONS[action]) invalidateShared();
    if (!hasAuth()) {
      // Client connecté côté Shopify mais jeton absent : configuration incomplète
      // (secret manquant). On n'écrit SURTOUT PAS en local à sa place.
      if (IS_CUSTOMER) {
        console.error('[lzApi] client connecté mais jeton Ma Collection absent (métachamp boutique lzmc.secret ?)');
        return { ok: false, error: 'auth_unavailable' };
      }
      return guestCall(action, payload || {});
    }
    if (!ANON_KEY) return { ok: false, error: 'missing_anon_key' };
    if (!tokenFresh()) await refreshAuth();
    var attempt = 0;
    while (true) {
      try {
        var body = await parse(await send(action, payload, opts.keepalive));
        if (!body.ok && (body.error === 'auth_expired' || body.error === 'auth_invalid') && attempt === 0) {
          attempt++;
          if (await refreshAuth()) continue;
        }
        if (!body.ok && body.error === 'rate_limited' && attempt < 2) {
          attempt++;
          await wait(1500 * attempt);
          continue;
        }
        return body;
      } catch (err) {
        if (attempt < 1) { attempt++; await wait(1000); continue; }
        console.warn('[lzApi] réseau indisponible pour', action);
        return { ok: false, error: 'network_error' };
      }
    }
  }

  // --------------------------------------------------------------------------
  // Progression : dédoublonnage + regroupement (1 requête par vrai changement)
  // --------------------------------------------------------------------------
  var lastSent = {};   // clé série -> JSON du dernier état envoyé avec succès
  // Univers dont la collection a bien été chargée sur cette page. Sans chargement
  // réussi, les traqueurs comptent 0 carte cochée : envoyer cette progression
  // effacerait celle du client (constat PS-05 / BD-14). On ne l'envoie donc pas.
  var loadedOk = {};
  var U_CANON = { pkm: 'pkm', pokemon: 'pkm', op: 'op', lor: 'lor', lorcana: 'lor', naruto: 'naruto', nar: 'naruto' };
  function canonU(u) { return U_CANON[String(u || '').toLowerCase()] || String(u || ''); }
  var pendingSync = {}; // clé série -> { payload, timer, waiters[] }

  function emitState(p) {
    try { document.dispatchEvent(new CustomEvent('lz:mc:state', { detail: p })); } catch (e) {}
  }

  function flushSync(key, keepalive) {
    var job = pendingSync[key];
    if (!job) return;
    delete pendingSync[key];
    clearTimeout(job.timer);
    var snapshot = JSON.stringify(job.payload);
    var res = lastSent[key] === snapshot
      ? Promise.resolve({ ok: true, data: { synced: false, skipped: 'unchanged' } })
      : call('collection.syncProgress', job.payload, { keepalive: keepalive }).then(function (r) {
          if (r && r.ok) lastSent[key] = snapshot;
          return r;
        });
    res.then(function (r) { job.waiters.forEach(function (w) { w(r); }); });
  }

  function syncProgress(o) {
    var payload = {
      universe: o.universe, series_handle: o.seriesHandle, series_title: o.seriesTitle || '',
      total_cards: o.totalCards || 0, owned_cards: o.ownedCards || 0,
      total_reverse_cards: o.totalReverseCards || 0, owned_reverse_cards: o.ownedReverseCards || 0,
    };
    emitState(payload);
    if (!payload.series_handle) return Promise.resolve({ ok: false, error: 'invalid_series_handle' });
    if (hasAuth() && !loadedOk[canonU(payload.universe)]) {
      return Promise.resolve({ ok: true, data: { synced: false, skipped: 'collection_not_loaded' } });
    }
    var key = payload.universe + '|' + payload.series_handle;
    var job = pendingSync[key] || (pendingSync[key] = { waiters: [] });
    job.payload = payload;
    clearTimeout(job.timer);
    job.timer = setTimeout(function () { flushSync(key, false); }, 1500);
    return new Promise(function (resolve) { job.waiters.push(resolve); });
  }

  // Envoie ce qui reste en attente si l'utilisateur quitte la page.
  window.addEventListener('pagehide', function () {
    Object.keys(pendingSync).forEach(function (k) { flushSync(k, true); });
  });

  // --------------------------------------------------------------------------
  // Lectures partagées : plusieurs sections d'une même page (ex. les 4 grilles du
  // hub Pokémon) demandaient chacune les mêmes données (8 appels au lieu de 2,
  // constat HS-07). Une même lecture lancée dans les 5 s réutilise la réponse.
  // Toute écriture invalide ce cache.
  // --------------------------------------------------------------------------
  var shareCache = {};
  function shared(action) {
    var c = shareCache[action];
    if (c && Date.now() - c.at < 5000) return c.p;
    var p = call(action, {});
    shareCache[action] = { at: Date.now(), p: p };
    p.then(function (r) { if (!r || !r.ok) delete shareCache[action]; });
    return p;
  }
  function invalidateShared() { shareCache = {}; }

  // --------------------------------------------------------------------------
  // API publique
  // --------------------------------------------------------------------------
  var lzApi = {
    __v: 2,
    isLoggedIn: hasAuth,
    mode: function () { return hasAuth() ? 'account' : (IS_CUSTOMER ? 'unavailable' : 'guest'); },
    customerId: function () { return hasAuth() ? String(auth.cid) : null; },
    refreshAuth: refreshAuth,
    guest: guest,

    // ---- v1 (compatibles) ----
    ping: function () { return call('ping', {}); },
    collectionLoad: function (o) {
      return call('collection.load', { universe: o.universe }).then(function (r) {
        if (r && r.ok) loadedOk[canonU(o.universe)] = true;
        return r;
      });
    },
    toggleProduct: function (o) {
      return call('collection.toggleProduct', {
        universe: o.universe, product_id: o.productId, owned: !!o.owned,
        series_handle: o.seriesHandle || '', product_title: o.productTitle || '',
      });
    },
    toggleVariant: function (o) {
      return call('collection.toggleVariant', {
        universe: o.universe, variant_id: o.variantId, owned: !!o.owned,
        variant_kind: o.variantKind || '', series_handle: o.seriesHandle || '', product_title: o.productTitle || '',
      });
    },
    syncProgress: syncProgress,
    favoritesList: function () { return shared('favorites.list'); },
    favoritesToggle: function (o) {
      return call('favorites.toggle', { universe: o.universe, series_handle: o.seriesHandle, favorite: !!o.favorite });
    },
    preferencesGet: function () { return call('preferences.get', {}); },
    preferencesSet: function (o) { return call('preferences.set', { favorite_license: o.favoriteLicense }); },
    activityLog: function () { return call('activity.log', {}); },
    progressGetAll: function () { return shared('progress.getAll'); },

    // ---- v2 ----
    bootstrap: function () { return call('me.bootstrap', {}); },
    collectionLoadAll: function () {
      return call('collection.loadAll', {}).then(function (r) {
        if (r && r.ok) Object.keys(U_CANON).forEach(function (k) { loadedOk[U_CANON[k]] = true; });
        return r;
      });
    },
    /** items: [{ type: 'product'|'variant', id, owned, series_handle, product_title, variant_kind }] */
    bulkSet: function (o) { return call('collection.bulkSet', { universe: o.universe, items: o.items || [] }); },
    wishlistAdd: function (o) {
      return call('wishlist.add', {
        universe: o.universe, variant_id: o.variantId, product_id: o.productId || '',
        variant_kind: o.variantKind || '', series_handle: o.seriesHandle || '',
        product_title: o.productTitle || '', notify_email: o.notifyEmail === true,
      });
    },
    wishlistRemove: function (o) { return call('wishlist.remove', { variant_id: o.variantId }); },
    wishlistList: function (o) { return call('wishlist.list', { universe: (o && o.universe) || '' }); },
    /** Mesure : name ∈ cart_add, cart_add_bulk, wishlist_add, purchase_sync, guest_import… */
    track: function (o) { return hasAuth() ? call('events.track', o || {}, { keepalive: true }) : Promise.resolve({ ok: false }); },
    accountExport: function () { return call('account.export', {}); },
    accountDelete: function () { return call('account.delete', { confirm: 'SUPPRIMER' }); },

    /** @internal debug console */
    _call: call,
    _baseUrl: BASE_URL,
  };

  window.lzApi = lzApi;
  try { document.dispatchEvent(new CustomEvent('lz:api-ready')); } catch (e) {}
})();
